import { Tabs } from '@mantine/core';
import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { useAppSelector } from '@/Module/Store/Hook';
import { selectedTeacherSelector } from '@/Module/Teacher/Store/Selector/selectedTeacherSelector';
export const usePrepareTabData = () => {
  const teacher = useAppSelector(selectedTeacherSelector)!;
  const educationHistory = teacher.educationHistory?.split('\n') ?? [];
  const majorFieldHistory = teacher.majorFieldHistory?.split('\n') ?? [];
  const authorship = teacher.authorship?.split('\n') ?? [];
  const tabs: ReactNode[] = useMemo(() => {
    const output: ReactNode[] = [];
    if (majorFieldHistory.length > 0) {
      output.push(<Tabs.Tab value="سوابق تدریس" key="educationHistory">
          سوابق تدریس
        </Tabs.Tab>);
    }
    if (educationHistory.length > 0) {
      output.push(<Tabs.Tab value="تحصیلات" key="majorFieldHistory">
          تحصیلات
        </Tabs.Tab>);
    }
    if (authorship.length) {
      output.push(<Tabs.Tab value="تالیفات" key="authorship">
          تالیفات
        </Tabs.Tab>);
    }
    return output;
  }, [majorFieldHistory, authorship, educationHistory]);
  const panel: ReactNode[] = useMemo(() => {
    const output: ReactNode[] = [];
    if (majorFieldHistory.length > 0) {
      output.push(<Tabs.Panel value="سوابق تدریس" key="educationHistory">
          <ul>
            {majorFieldHistory.map(item => <li key={item} className="mb-4 flex items-center ">
                <span className="pr-2 text-base  text-blueSix sm:text-xl">{item}</span>
              </li>)}
          </ul>
        </Tabs.Panel>);
    }
    if (educationHistory.length > 0) {
      output.push(<Tabs.Panel value="تحصیلات" key="majorFieldHistory">
          {educationHistory.map(item => <li key={item} className="mb-4 flex items-center ">
              <span className="pr-2 text-base  text-blueSix sm:text-xl">{item}</span>
            </li>)}
        </Tabs.Panel>);
    }
    if (authorship.length) {
      output.push(<Tabs.Panel value="تالیفات" key="authorship">
          {authorship.map(item => <li key={item} className="mb-4 flex items-center ">
              <span className="pr-2 text-base  text-blueSix sm:text-xl">{item}</span>
            </li>)}
        </Tabs.Panel>);
    }
    return output;
  }, [educationHistory, majorFieldHistory]);
  return {
    tabs,
    panel
  };
};